import AutoQueryTagFilter from "servicestack/auto-query/auto-query-tag-filter.model";

class Item {
  constructor(keys, row) {
    this.tagLabel = `${row[keys[0]]}`;
    this.total = row[keys[1]];
  }
}

export default class AutoQueryGroupByFilter extends AutoQueryTagFilter {
  constructor(config, $aq) {
    const groupBy = (config.groupBy =
      config.groupBy || config.tag || config.toString());
    const title = (config.title = config.title || groupBy);
    super(config, $aq);
    const g = this;
    g.type = "groupBy";
    g.forceResetItems = true;
    g.groupBy = groupBy;
    g.$$url = `${
      $aq.url + ($aq.url.indexOf("?") > 0 ? "&" : "?")
    }GroupBy=${encodeURIComponent(groupBy)}`;
  }

  getParams() {
    const g = this;
    return (
      g.query.criteria[g.groupBy + "In"] ||
      (g.query.criteria[g.groupBy + "In"] = [])
    );
  }

  mapItems(res) {
    const g = this;
    g.rawResults = res.data.results;
    if (res.data.results.length === 0) {
      return [];
    }
    const keys = Object.keys(res.data.results[0]);
    const items =  res.data.results.map(row => new Item(keys, row));
    return g.onMappingItems ? g.onMappingItems.call(g, items) : items;
  }

  clear() {
    const g = this;
    delete g.query.criteria[g.groupBy + "In"];
  }

  readQueryString(fieldName, value) {
    const g = this;
    if (value && fieldName.toLowerCase() == g.groupBy.toLowerCase()) {
      g.query.criteria[g.groupBy + "In"] = (value || "").split("|");
    }
  }

  writeQueryString(params) {
    const g = this;
    let locals = g.getParams();
    if (locals.length)
      params[g.groupBy] = locals.join(AutoQueryTagFilter.qsDelimiter);
  }

  scrubParams(_params) {
    const g = this;
    let params = super.scrubParams(_params);
    delete params[g.groupBy + "In"];
    return params;
  }
}
